// eslint-disable-next-line import/prefer-default-export
export const subscribeRegisterTokenSerializer = (data = {}) => {
  const newData = {
    id: data.id,
    cockpitId: data.cockpitId,
    value: data.value,
    createdAt: data.createdAt
  }

  return newData
}
